import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Typography } from '@mui/material';
import { tokens } from '../theme';
import site from '../content';
import { BrandMark } from './Navbar';

const linkSx = {
  color: tokens.muted,
  textDecoration: 'none',
  fontSize: '0.9rem',
  '&:hover': { color: tokens.text },
  '&:focus-visible': { outline: `2px solid ${tokens.accentStrong}`, outlineOffset: 2, borderRadius: 0.5 },
};

const FooterLink = ({ to, children }) => (
  <Box component="li">
    <Box component={RouterLink} to={to} sx={linkSx}>{children}</Box>
  </Box>
);

const Footer = () => (
  <Box component="footer" sx={{ borderTop: `1px solid ${tokens.line}`, pt: 6, pb: 4, mt: 'auto' }}>
    <Container maxWidth="lg">
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1.4fr 1fr 1fr' },
          gap: { xs: 4, sm: 6 },
          mb: 5,
        }}
      >
        <Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.5 }}>
            <BrandMark size={18} />
            <Typography sx={{ fontWeight: 600 }}>{site.siteName}</Typography>
          </Box>
          <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 320 }}>
            Replace the logo in PDF, Word and PowerPoint files. Free, and files are deleted after download.
          </Typography>
        </Box>

        <Box component="nav" aria-label="File types">
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 1.5 }}>Replace a logo in</Typography>
          <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, display: 'grid', gap: 1 }}>
            {site.formats.map((f) => <FooterLink key={f.path} to={f.path}>{f.name}</FooterLink>)}
          </Box>
        </Box>

        <Box component="nav" aria-label="Company">
          <Typography variant="body2" sx={{ fontWeight: 600, mb: 1.5 }}>{site.siteName}</Typography>
          <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0, display: 'grid', gap: 1 }}>
            <FooterLink to={site.about.path}>About</FooterLink>
            <FooterLink to={site.privacy.path}>Privacy</FooterLink>
            <FooterLink to={site.terms.path}>Terms</FooterLink>
            <Box component="li">
              <Box component="a" href={`mailto:${site.contactEmail}`} sx={linkSx}>Contact</Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: 2, pt: 3, borderTop: `1px solid ${tokens.line}` }}>
        <Typography variant="body2" color="text.secondary">
          © {new Date().getFullYear()} {site.siteName}. Made by{' '}
          <Box component={RouterLink} to={site.about.path} sx={{ color: 'inherit' }}>{site.founder}</Box>.
        </Typography>
        <a href={`${site.productHuntUrl}?embed=true&utm_source=badge-featured&utm_medium=badge&utm_source=badge-replogo`} target="_blank" rel="noopener noreferrer">
          <img
            src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=994343&theme=dark&t=1753128268952"
            alt="RepLogo on Product Hunt"
            width="200"
            height="43"
            style={{ display: 'block' }}
          />
        </a>
      </Box>
    </Container>
  </Box>
);

export default Footer;
